
<!-- <div class="custombg fixed-top">
  <app-header #header></app-header>
  <app-breadcrumb></app-breadcrumb>
</div> -->
<div id="customer_project_modal" class="modal fade " data-toggle="modal" tabindex="-1" role="dialog" aria-labelledby="myLargeModalLabel" aria-hidden="true">
  <div class="modal-dialog modal-lg">
    <div class="modal-content">
      <div class="card-border card">
        <div class="header"></div>
        <div class="card-body">
          <div class="card-title">High level Summary</div>
          <p class="card-text modal_header mb-2">
            <b>
              Virtual Credit Card Payments Project Comments
              Stand up a Virtual Credit Card provider payment solution for Amisys (legacy Centene), by developing a
              solution to move paper check providers to a virtual credit card solution:
            </b></p>
          <ul>
            <li>
              Enable provider set up at Change HealthCare (CHC) as described below.
            </li>
            <li>Enable claims payments via virtual credit cards as described below. </li>
            <li>Migrate paper check / EOP (Explanation of Payment) communications with CHC to 835s as described below.
            </li>
            <li>Enable key reports / dashboards as described below.  </li>
            <li>Rollout the new capabilities to all Health Plans /
              LOBs.</li>
          </ul>
          <p class="modal_header"><b>Current Week Accomplishments</b></p>
          <ol>
            <li>PFF tested and ready for PROD.</li>
            <li>Dashboard requirement gathered, Awaiting some clarification.</li>
          </ol>
          <p class="modal_header"><b>Planned Activities</b></p>
          <ol>
            <li>PFF - UAT sign-off; PROD go-live.</li>
            <li>Dashboard -> Proceed on development Risks.</li>
          </ol>
          <p class="modal_header"><b>Overall delay on the project go-live due to dependency with Change Healthcare and UAT sign-off.</b></p>
          <ol>
            <li>PFF UAT sign-off by 10/13; Go-live by 10/14.</li>
            <li>Intermediate milestone payments as CR approval in-progress.</li>
          </ol>
          <p class="modal_header"><b>Back to Green Plan</b></p>
          <ol>
            <li>UAT Sign-off for PFF by this week.</li>
            <li>CR sign-off by this week.</li>
          </ol>
          <div class="text-end">
            <button class="btn btn-dark btn-flat" data-dismiss="modal">Close</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
<!-- <div class="modal fade summary_modal" id="customModal1" tabindex="-1" role="dialog"
    aria-labelledby="exampleModalLabel" aria-hidden="true">
    <div class="modal-dialog">
     
    </div>
</div> -->
  <section class="position-relative pt-1">
    <div class="container-fluid">
      <div class="row">
        <nav id="sidebarMenu" class="d-md-block sidebar collapse">
          <div class="position-sticky">
            <ul class="nav flex-column">
              <li class="nav-item">
                <a class="nav-link active" aria-current="page" href="javascript:void(0)" (click)="navigate(projectStatus)" >
                  <span class="ps-1">Project Status</span>
                </a>
              </li>
              <li class="nav-item">
                <a class="nav-link" aria-current="page" href="javascript:void(0)" (click)="navigate(customerMap)"> 
                  <span class="ps-1">Customer Map</span>
                </a>
              </li>
              <li class="nav-item">
                <a class="nav-link" aria-current="page" href="javascript:void(0)" (click)="navigate(serviceHeatMap)">
                  <span class="ps-1">Service Heat Map</span>
                </a>
              </li>
              <li class="nav-item">
                <a class="nav-link" aria-current="page" href="javascript:void(0)" (click)="navigate(proposal)">
                  <span class="ps-1">Proposals</span>
                </a>
              </li>
              <li class="nav-item">  
                <a class="nav-link" aria-current="page" href="javascript:void(0)" (click)="navigate(demandDetails)">
                  <span class="ps-1">Demand Details</span>
                </a>
              </li>
              <li class="nav-item">
                <a class="nav-link" aria-current="page" href="javascript:void(0)" (click)="navigate(resourcePyramid)">
                  <span class="ps-1">Resource Pyramid</span>
                </a>
              </li>
              <li class="nav-item">  
                <a class="nav-link" aria-current="page" href="javascript:void(0)" (click)="navigate(focusArea)">
                  <span class="ps-1">Focus Areas</span>
                </a>
              </li>
              <li class="nav-item">
                <a class="nav-link" aria-current="page" href="javascript:void(0)" (click)="navigate(notes)">
                  <span class="ps-1">Notes</span>
                </a>
              </li>
            </ul>
          </div>
        </nav>
        <main class="main">
          <section class="mb-3 centene_management_sec">
            <div class="row">
              <!-- Management Section -->
              <div class="col-lg-4">
                <div class="centene-management-card mt-3">
                  <h1>Centene Management Company, LLC</h1>
                  <div class="vertical-remit">
                    <ul class="d-flex">
                      <li><span>Vertical</span> <strong>REMTT</strong></li>
                      <li><span>Sub Vertical</span> <strong>RETAIL</strong></li>
                    </ul>
                  </div>
                </div>
                <div class="centene-management-table">
                  <table>
                    <tr>
                      <td  class="label_name">Portfolio Leader </td>
                      <td class="label_value">Sureshkumar R </td>
                    </tr>
                    <tr>
                      <td class="label_name">Delivery Manager </td>
                      <td class="label_value">Santosh Kumar Chandrasekaran</td>
                    </tr>
                    <tr>
                      <td class="label_name">Client Partner</td>
                      <td class="label_value">Amit Mirchandani </td>
                    </tr>
                    <tr>
                      <td class="label_name">Sub Vertical Leader </td>
                      <td class="label_value">Prasenjit Paul</td>
                    </tr>
                    <tr>
                      <td class="label_name">SBU Leader</td>
                      <td class="label_value">Ashish Saxena</td>
                    </tr>
                  </table>
                </div>
              </div>
              <div class="col-lg-8">
                <div class="customer-tenure-blk mt-3">
                  <img src="./../../../../../assets/images/c360_new/changes_new/tenure 3.svg" alt="">
                </div>
              </div>
            </div>
          </section>
          <section class="account_details text-center ps-5">
            <div class="account-details-blk mt-3">
              <img src="./../../../../../assets/images/c360_new/Changes/Accountdtls-latest.svg" alt="Account details">
            </div>
          </section>
          <!-- Accordion -->
          <mat-card-content class="mx-0 my-0 p-0 c360">
            <mat-accordion id="projectStatus" #projectStatus>
                <mat-expansion-panel class="mt-3 mat-panel-expansion matexpansions" [expanded]="true">
                    <mat-expansion-panel-header class="m-0 accordion_panel_header" >
                        <mat-panel-title class="heading_card fw-600 field_heading" >
                            Project Status
                        </mat-panel-title>
                    </mat-expansion-panel-header>
                    <div class="projectStatus">
                        <img src="./../../../../../assets/images/c360_new/Changes/projectstatus_latest.svg" alt="Account details" width="100%" height="100%" usemap="#image-map">
                        <!-- <img src="projectstatus.svg" usemap="#image_map">
                        <map name="image_map">
                          <area alt="" title="" href="" coords="588,29,926,353" shape="rect">
                        </map> -->
                        <map name="image-map">
                          <area target="" alt="" title="" 
                          data-toggle="modal" data-target="#customer_project_modal"
                            coords="589,28,928,66" shape="rect" class="mapping-img">
                        </map>
                    </div>
                </mat-expansion-panel>
            </mat-accordion>
            <mat-accordion id="customerMap" #customerMap>
                <mat-expansion-panel class="mt-3 mat-panel-expansion matexpansions" [expanded]="true">
                    <mat-expansion-panel-header class="m-0  accordion_panel_header" >
                        <mat-panel-title class="heading_card fw-600 field_heading">
                            Customer Map
                        </mat-panel-title>
                    </mat-expansion-panel-header>
                    <div class="customerMap">
                        <img src="./../../../../../assets/images/c360_new/Changes/CustomerMap_latest.svg" alt="Account details" width="100%" height="100%">
                    </div>
                </mat-expansion-panel>
            </mat-accordion>
            <mat-accordion id="serviceHeatMap" #serviceHeatMap>
                <mat-expansion-panel class="mt-3 mat-panel-expansion matexpansions" [expanded]="true">
                    <mat-expansion-panel-header class="m-0  accordion_panel_header" >
                        <mat-panel-title class="heading_card fw-600 field_heading">
                            Service Heat Map
                        </mat-panel-title>
                    </mat-expansion-panel-header>
                    <div class="serviceHeatMap">
                        <img src="./../../../../../assets/images/c360_new/changes_new/ServiceHeatmap 1.svg" alt="serviceHeatMap" width="100%" height="100%">
                    </div>
                </mat-expansion-panel>
            </mat-accordion>
            <mat-accordion id="proposal" #proposal>
                <mat-expansion-panel class="mt-3 mat-panel-expansion matexpansions" [expanded]="true" >
                    <mat-expansion-panel-header class="m-0  accordion_panel_header">
                        <mat-panel-title class="heading_card fw-600 field_heading">
                            Proposals
                        </mat-panel-title>
                    </mat-expansion-panel-header>
                    <div class="proposal">
                        <img src="./../../../../../assets/images/c360_new/changes_new/proposal 2.svg" alt="proposal" width="100%" height="100%">
                    </div>
                </mat-expansion-panel>
            </mat-accordion>
            <mat-accordion  id="demandDetails" #demandDetails>
                <mat-expansion-panel class="mt-3 mat-panel-expansion matexpansions" [expanded]="true">
                    <mat-expansion-panel-header class="m-0  accordion_panel_header">
                        <mat-panel-title class="heading_card fw-600 field_heading">
                            Demand Details
                        </mat-panel-title>
                    </mat-expansion-panel-header>
                    <div class="demandDetails">
                        <img src="./../../../../../assets/images/c360_new/Changes/demand-latest.svg" alt="demandDetails" width="100%" height="100%">
                    </div>
                </mat-expansion-panel>
            </mat-accordion>
            <mat-accordion id="resourcePyramid" #resourcePyramid>
                <mat-expansion-panel class="mt-3 mat-panel-expansion matexpansions" [expanded]="true" >
                    <mat-expansion-panel-header class="m-0  accordion_panel_header" >
                        <mat-panel-title class="heading_card fw-600 field_heading">
                           Resource Pyramid
                        </mat-panel-title>
                    </mat-expansion-panel-header>
                    <div  class="resourcePyramid">
                        <img src="./../../../../../assets/images/c360_new/changes_new/Resource_pyramid 2.svg" alt="resourcePyramid" width="100%" height="100%">
                    </div>
                </mat-expansion-panel>
            </mat-accordion>
            <mat-accordion id="focusArea" #focusArea>
              <mat-expansion-panel class="mt-3 mat-panel-expansion matexpansions" [expanded]="true" >
                  <mat-expansion-panel-header class="m-0  accordion_panel_header" >
                      <mat-panel-title class="heading_card fw-600 field_heading">
                         Focus Areas
                      </mat-panel-title>
                  </mat-expansion-panel-header>
                  <div  class="resourcePyramid">
                      <img src="./../../../../../assets/images/c360_new/changes_new/Major_focus areas 1.svg" alt="focusArea" width="100%" height="100%">
                  </div>
              </mat-expansion-panel>
          </mat-accordion>
          <mat-accordion id="notes" #notes>
            <mat-expansion-panel class="mt-3 mat-panel-expansion matexpansions" [expanded]="true" >
                <mat-expansion-panel-header class="m-0  accordion_panel_header" >
                    <mat-panel-title class="heading_card fw-600 field_heading">
                       Notes
                    </mat-panel-title>
                </mat-expansion-panel-header>
                <div  class="Notes">
                    <img src="./../../../../../assets/images/c360_new/changes_new/Notes 1.svg" alt="notes" width="100%" height="100%">
                </div>
            </mat-expansion-panel>
        </mat-accordion>
        </mat-card-content>
        </main>
      </div>
    </div>
  </section>



<!-- <div class="customer_detail">
    <div class="side_nav">
        <ul class="">
          <li class="nav-item">
            <a class="nav-link active" aria-current="page" data-id="#projectStatus">
              <span class="ps-1">Project Status</span>
            </a>
          </li>
          <li class="nav-item">
            <a class="nav-link" data-id="#customerMap">
              <span class="ps-1">Customer map</span>
            </a>
          </li>
          <li class="nav-item">
            <a class="nav-link" data-id="#serviceHeatMap">
              <span class="ps-1">Service Heat Map</span>
            </a>
          </li>
          <li class="nav-item">
            <a class="nav-link" data-id="#proposal">
              <span class="ps-1">Proposal</span>
            </a>
          </li>
          <li class="nav-item">
            <a class="nav-link" data-id="#demandDetails">
              <span class="ps-1">Demand Details</span>
            </a>
          </li>
          <li class="nav-item">
            <a class="nav-link" data-id="#resource_Pyramid">
              <span class="ps-1">Resource Pyramid</span>
            </a>
          </li>
    
        </ul>
      </div>
    <div class="right_content">
        <div class="row">
            <div class="col-lg-4">
              <div class="centene-management-card mt-3">
                <h1>Centene Management Company, LLC</h1>
                <div class="vertical-remit">
                  <ul class="d-flex">
                    <li><span>Vertical</span> <strong>REMTT</strong></li>
                    <li><span>Sub Vertical</span> <strong>RETAIL</strong></li>
                  </ul>
                </div>
              </div>
              <div class="centene-management-table">
                <table>
                  <tr>
                    <td>Portfolio Leader </td>
                    <td>Sureshkumar R </td>
                  </tr>
                  <tr>
                    <td>Delivery Manager </td>
                    <td>Santosh Kumar Chandrasekaran</td>
                  </tr>
                  <tr>
                    <td>Client Partner</td>
                    <td>Amit Mirchandani </td>
                  </tr>
                  <tr>
                    <td>Sub-vertical Leader </td>
                    <td>Prasenjit Paul</td>
                  </tr>
                  <tr>
                    <td>SBU Leader</td>
                    <td>Ashish Saxena</td>
                  </tr>
                </table>
              </div>
            </div>
            <div class="col-lg-8">
              <div class="customer-tenure-blk mt-3">
                <img src="./../../../../../assets/images/tenure.svg" alt="">
              </div>
            </div>
          </div>
        <mat-card-content class="mx-0 my-0 p-0">
            <mat-accordion>
                <mat-expansion-panel class="mt-3 mat-panel-expansion matexpansions" [expanded]="true">
                    <mat-expansion-panel-header class="m-0 bder-bottom accordion_panel_header">
                        <mat-panel-title class="h3 fw-600 field_heading">
                            Project status
                        </mat-panel-title>
                    </mat-expansion-panel-header>
                    <div style="margin: 30px">
                        <img src="./../../../../../assets/images/customer-360/projectstatus.svg" alt="Account details" width="100%" height="100%">
                    </div>
                </mat-expansion-panel>
            </mat-accordion>
            <mat-accordion>
                <mat-expansion-panel class="mt-3 mat-panel-expansion matexpansions" [expanded]="true">
                    <mat-expansion-panel-header class="m-0 bder-bottom accordion_panel_header">
                        <mat-panel-title class="h3 fw-600 field_heading">
                            Customer map
                        </mat-panel-title>
                    </mat-expansion-panel-header>
                    <div style="margin: 30px">
                        <img src="./../../../../../assets/images/customer-360/CustomerMap.png" alt="Account details" width="100%" height="100%">
                    </div>
                </mat-expansion-panel>
            </mat-accordion>
            <mat-accordion>
                <mat-expansion-panel class="mt-3 mat-panel-expansion matexpansions" [expanded]="true">
                    <mat-expansion-panel-header class="m-0 bder-bottom accordion_panel_header">
                        <mat-panel-title class="h3 fw-600 field_heading">
                            Service Heat map
                        </mat-panel-title>
                    </mat-expansion-panel-header>
                    <div style="margin: 30px">
                        <img src="./../../../../../assets/images/customer-360/serviceHeatmap.svg" alt="Account details" width="100%" height="100%">
                    </div>
                </mat-expansion-panel>
            </mat-accordion>
            <mat-accordion>
                <mat-expansion-panel class="mt-3 mat-panel-expansion matexpansions" [expanded]="true">
                    <mat-expansion-panel-header class="m-0 bder-bottom accordion_panel_header">
                        <mat-panel-title class="h3 fw-600 field_heading">
                            Propasal
                        </mat-panel-title>
                    </mat-expansion-panel-header>
                    <div style="margin: 30px">
                        <img src="./../../../../../assets/images/customer-360/proposal.svg" alt="Account details" width="100%" height="100%">
                    </div>
                </mat-expansion-panel>
            </mat-accordion>
            <mat-accordion>
                <mat-expansion-panel class="mt-3 mat-panel-expansion matexpansions" [expanded]="true">
                    <mat-expansion-panel-header class="m-0 bder-bottom accordion_panel_header">
                        <mat-panel-title class="h3 fw-600 field_heading">
                            Demand Details
                        </mat-panel-title>
                    </mat-expansion-panel-header>
                    <div style="margin: 30px">
                        <img src="./../../../../../assets/images/customer-360/demand.svg" alt="Account details" width="100%" height="100%">
                    </div>
                </mat-expansion-panel>
            </mat-accordion>
            <mat-accordion>
                <mat-expansion-panel class="mt-3 mat-panel-expansion matexpansions" [expanded]="true">
                    <mat-expansion-panel-header class="m-0 bder-bottom accordion_panel_header">
                        <mat-panel-title class="h3 fw-600 field_heading">
                           Resource Pyramid
                        </mat-panel-title>
                    </mat-expansion-panel-header>
                    <div style="margin: 30px">
                        <img src="./../../../../../assets/images/customer-360/ResourcePeramid1.png" alt="Account details" width="100%" height="100%">
                    </div>
                </mat-expansion-panel>
            </mat-accordion>
        </mat-card-content>
    </div>
</div> -->